import { useEffect, useState } from 'react';

// TODO: Заменить на useDebounce из lib-utils, когда он там появится
export function useDebounce(value, delay = 150) {
  const [debouncedValue, setDebouncedValue] = useState();

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debouncedValue;
}
